module.exports = __webpack_public_path__ + "static/media/publish-simultaneous-tablet-en.ecc09f24.png";